import { makeStyles } from '@mui/styles';

const useSingleDivisionContainerStyles = makeStyles({
	root: {
		position: 'relative',
	},
	container: {
		paddingBottom: 24,
		paddingLeft: 24,
		paddingRight: 24,
		paddingTop: 31,
	},
	containerEditing: {
		maxWidth: 'calc(100% - 400px)',
	},
	titleContainer: {
		alignItems: 'center',
		display: 'flex',
		gap: 6,
		marginBottom: 17,
	},
});

export default useSingleDivisionContainerStyles;
